import React, { useState, useEffect, startTransition } from 'react';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  useTheme,
  alpha
} from '@mui/material';
import {
  Home,
  HomeOutlined,
  Settings,
  SettingsOutlined,
} from '@mui/icons-material';
import { GiStethoscope } from "react-icons/gi";
import { PiStethoscopeLight } from "react-icons/pi";
import { IoCalendarOutline, IoCalendarSharp, IoMedicalOutline, IoMedicalSharp } from "react-icons/io5";
import { useLocation, useNavigate } from 'react-router-dom';

// Reusable icon wrapper with subtle animation
const IconWrapper = ({ icon: Icon, selected }) => (
  <div style={{
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: selected ? 'scale(1.15)' : 'scale(1)',
    transition: 'transform 0.25s ease-out',
  }}>
    <Icon style={{ width: '100%', height: '100%', color: 'inherit' }} />
  </div>
);

const SPBottomNavBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const theme = useTheme();

  // Sync active tab with route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/sp/patients')) setValue(1);
    else if (path.includes('/sp/appointments')) setValue(2);
    else if (path.includes('/sp/doctors')) setValue(3);
    else if (path.includes('/sp/settings')) setValue(4);
    else setValue(0);
  }, [location]);

  // Handle navigation with startTransition
  const handleNavigation = (newValue) => {
    setValue(newValue);
    startTransition(() => {
      switch(newValue) {
        case 0:
          navigate('/sp/dashboard');
          break;
        case 1:
          navigate('/sp/patients');
          break;
        case 2:
          navigate('/sp/appointments');
          break;
        case 3:
          navigate('/sp/doctors');
          break;
        case 4:
          navigate('/sp/settings');
          break;
        default:
          navigate('/sp/dashboard');
      }
    });
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        // borderRadius: '24px 24px 24px 24px',
       
        maxWidth: 800,
      borderRadius :0,
        background: `linear-gradient(145deg, ${alpha(theme.palette.common.white, 1)}, ${alpha(theme.palette.common.white, 1)})`,
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
        boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
        overflow: 'hidden',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      elevation={0}
    >
      <BottomNavigation
        value={value}
        onChange={(e, newValue) => handleNavigation(newValue)}
        sx={{
          height: 70,
          padding: '0 10px',
          
          background: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            color: alpha(theme.palette.primary.main, 2),
            padding: '10px 0',
            transition: 'color 0.3s',
            '&.Mui-selected': {
              color: theme.palette.primary.text,
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.75rem',
              fontWeight: 500,
              transition: 'all 0.3s',
              transform: 'translateY(2px)',
              '&.Mui-selected': {
                fontSize: '0.8rem',
                fontWeight: 600,
                transform: 'translateY(0px)',
              },
            },
          }
        }}
        showLabels
      >
        <BottomNavigationAction
          label="Home"
          icon={<IconWrapper icon={value === 0 ? Home : HomeOutlined} selected={value === 0} />}
        />
        <BottomNavigationAction
          label="Patients"
          icon={<IconWrapper icon={value === 1 ? IoMedicalSharp : IoMedicalOutline} selected={value === 1} />}
        />
        <BottomNavigationAction
          label="Appointments"
          icon={<IconWrapper icon={value === 2 ? IoCalendarSharp : IoCalendarOutline} selected={value === 2} />}
        />
        <BottomNavigationAction
          label="Doctors"
          icon={<IconWrapper icon={value === 3 ? GiStethoscope : PiStethoscopeLight} selected={value === 3} />}
        />
        <BottomNavigationAction
          label="Settings"
          icon={<IconWrapper icon={value === 4 ? Settings : SettingsOutlined} selected={value === 4} />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default SPBottomNavBar;
